import React from 'react';
import { stats as fallbackStats } from '../mock';
import { useApp } from '../context/AppContext';
import { Star, BadgeCheck } from 'lucide-react';

export const StatsBar = () => {
  const { t, settings } = useApp();
  const stats = (settings?.stats && settings.stats.length) ? settings.stats : fallbackStats;
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 pt-16 md:pt-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2 grid grid-cols-3 gap-4">
          {stats.map((s) => (
            <div key={s.key} className="bg-white rounded-xl border border-gobra-sand p-5 md:p-7 text-center">
              <div className="font-title text-2xl md:text-4xl font-bold text-gobra-green">{s.value}</div>
              <div className="text-xs md:text-sm text-muted-foreground mt-1">{t(s.key)}</div>
            </div>
          ))}
        </div>
        <div className="bg-gobra-slate rounded-xl p-5 md:p-7 flex flex-col justify-center text-white">
          <div className="flex items-center gap-1 text-gobra-orange mb-2">
            {[...Array(5)].map((_, i) => <Star key={`star-${i}`} className="h-4 w-4 fill-gobra-orange" />)}
          </div>
          <div className="font-title text-lg font-semibold">1,500+ Five-Star Reviews</div>
          <p className="text-white/70 text-sm mt-1">{t('one_partner')}</p>
        </div>
      </div>
    </section>
  );
};

export const DevelopersStrip = () => {
  const { t, developers, settings } = useApp();
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-20">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 text-gobra-terracotta text-sm font-semibold mb-2">
          <BadgeCheck className="h-4 w-4" /> {settings?.name || 'GOBRA Capital Real Estate'}
        </div>
        <h2 className="font-title text-2xl md:text-3xl font-bold text-gobra-slate">{t('trusted_developers')}</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {developers.map((d) => (
          <div key={d.id} className="bg-white border border-gobra-sand rounded-xl py-6 px-3 flex flex-col items-center justify-center hover:border-gobra-green transition-colors group min-h-[104px]">
            {d.logo ? (
              <img src={d.logo} alt={d.name} className="h-10 md:h-12 w-full object-contain" loading="lazy" />
            ) : (
              <span className="font-title text-xl font-bold text-gobra-slate group-hover:text-gobra-green transition-colors tracking-wide text-center">{d.name}</span>
            )}
            {d.tagline ? <span className="text-[10px] tracking-[0.25em] text-muted-foreground uppercase mt-1.5 text-center">{d.tagline}</span> : null}
          </div>
        ))}
      </div>
    </section>
  );
};
